import { useMutation } from "react-query";
import { createApiWithPath } from "../../client";

const deleteFieldType = async (id: string): Promise<void> => {
  await createApiWithPath("crm").delete(`/field-types/${id}`);
};

export const useDeleteFieldType = () => {
  return useMutation((id: string) => deleteFieldType(id));
};
